import { useEffect, useRef } from 'react';

const MatrixBackground = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // More champagne bottles and drinks
    const drinks = [
      '🍾', '🍾', '🍾', '🍾', '🍾', '🍾',  // More champagne
      '🥂', '🥂', '🥂', '🥂',              // Champagne glasses
      '🍺', '🍺', '🍻', '🍻',              // Beers
      '🥃', '🥃', '🍸', '🍸',              // Cocktails
      '🍹', '🍷', '🧊'                      // Other drinks
    ];
    
    const spacing = 14; // Even tighter for more density
    const columns = Math.floor(canvas.width / spacing);

    const drops = [];
    for (let i = 0; i < columns; i++) {
      drops[i] = {
        y: Math.random() * canvas.height,
        speed: 2.5 + Math.random() * 4,
        emoji: drinks[Math.floor(Math.random() * drinks.length)],
        opacity: 0.5 + Math.random() * 0.4,
        size: 14 + Math.random() * 8
      };
    }

    const draw = () => {
      ctx.fillStyle = '#0f172a';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      for (let i = 0; i < drops.length; i++) {
        const drop = drops[i];
        const x = i * spacing + 4;
        
        ctx.globalAlpha = drop.opacity;
        ctx.font = `${drop.size}px Arial`;
        ctx.fillText(drop.emoji, x, drop.y);

        drop.y += drop.speed;

        if (drop.y > canvas.height + 25) {
          drop.y = -25;
          drop.emoji = drinks[Math.floor(Math.random() * drinks.length)];
          drop.speed = 2.5 + Math.random() * 4;
          drop.opacity = 0.5 + Math.random() * 0.4;
          drop.size = 14 + Math.random() * 8;
        }
      }
      
      ctx.globalAlpha = 1;
    };

    const interval = setInterval(draw, 25);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 pointer-events-none"
      style={{ zIndex: 0 }}
    />
  );
};

export default MatrixBackground;
